

<template>

<div>
    <div style="width:100%">
        <NavBar test="Signup"></NavBar>
    </div>
    <v-row style="margin-top:2%" align="center" justify="center">
        <v-card width="750px" height="450px">
            <v-form ref="register" class="pa-6" lazy-validation>
                <v-row style="height: 70px;">
                    <v-col cols="5">
                        <v-text-field v-model="fname" dense :rules="[rules.required]" type="text" required label="First Name:" outlined></v-text-field>
                    </v-col>
                    <v-col></v-col>
                    <v-col cols="5">
                        <v-text-field v-model="lname" :rules="[rules.required]" dense type="text" required label="Last Name:" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row style="height: 70px;">
                    <v-col cols="5">
                        <v-text-field v-model="username" dense :rules="[rules.required]" type="text" required label="Username:" outlined></v-text-field>
                    </v-col>
                    <v-col></v-col>
                    <v-col cols="5">
                        <v-text-field v-model="email" :rules="[rules.required,rules.email]" dense type="email" required label="Email:" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row style="height: 70px;">
                    <v-col cols="5">
                        <v-text-field type="password" v-model="pass" dense :rules="[rules.required,rules.pass]" required label="Password:" outlined></v-text-field>
                    </v-col>
                    <v-col></v-col>
                    <v-col cols="5">
                        <v-text-field type="password" v-model="conpass" :rules="[rules.pass,confirm]" dense required label="Confirm Password:" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row style="height: 70px;">
                    <v-col cols="5">
                        <v-text-field v-model="city" dense :rules="[rules.required]" type="text" required label="City:" outlined></v-text-field>
                    </v-col>
                    <v-col></v-col>
                    <v-col cols="5">
                        <v-text-field v-model="address" :rules="[rules.required]" dense type="text" required label="Address" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" style="margin-top:3%">
                    <v-btn class="ma-2" style="width:150px" elevation="2" depressed color="primary" @click="register">
                        Register
                    </v-btn>
                </v-row>
            </v-form>
        </v-card>
    </v-row>
</div>

</template>

<script>

import NavBar from './NavBar.vue'
import {
    APIService
}
from '../Api.js'

const api = new APIService();
export default {
    components: {
        NavBar,
    },
    data: () => ({
        fname: '',
        lname: '',
        email: '',
        username: '',
        pass: '',
        conpass: '',
        city: '',
        address: '',
        isLoading: false,
        rules: {
            required: value => !!value || 'Required.',
            pass: value => {

              var re = /^(?=.*\d)/

               if(!re.test(value))
                 return "Alphanumeric password required"

               re = /^(?=.*[a-z])/
               if(!re.test(value))
                 return "Alphanumeric password required"

              re = /^(?=.*[A-Z])/
              if(!re.test(value))
                return "Capital letter required"

              re = /^\w{6,}$/
              if(!re.test(value))
                return "minimum 6 letters required"

              return true
            },
            email: value => {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(value) || 'Invalid Email'
            }
        },
    }),

    methods: {
        confirm(value) {
                if (this.pass.localeCompare(value) == 0)
                    return true
                else
                    return "Password does not match"
            },
            register() {
                if (this.$refs.register.validate()) {
                    this.$overlay.show(this);
                    api.register(this.fname, this.lname, this.username, this.email, this.pass, this.city, this.address).then((response) => {
                        if (response.status == 200) {
                            this.$toasted.success("User registered").goAway(800);
                            this.$router.push("/login");
                        }
                        this.$overlay.hide();
                    }).catch(error => {
                        this.$toasted.error("Network Error").goAway(800);
                        this.$overlay.hide();
                    })
                }
            }

    }
}

</script>
